import { Client } from 'urql';
import { streetPageQuery } from './streetPageQuery';

export const fetchStreetPage = async ({
  client,
  slug,
  toggleSuburbCTA,
}: {
  client: Client;
  slug: string;
  toggleSuburbCTA: boolean;
}) => {
  const { data, error } = await client
    .query(streetPageQuery, { slug, toggleSuburbCTA })
    .toPromise();
  return { data, error };
};
